import { gql, TypedDocumentNode } from '@apollo/client';

import { JobBoardDto, QueryGetCandidateConnectionsArgs } from '@pflegia/data-access';

import { jobPositionQueryFields } from '../fragments/job-position-query-fields';

export const GET_CONNECTIONS_BY_CANDIDATE_ID: TypedDocumentNode<{ data: JobBoardDto }, QueryGetCandidateConnectionsArgs> = gql`
  query getCandidateConnections(
    $connectionType: [String!]!
    $connectionStatus: String
    $offerType: String
    $offset: Float
    $limit: Float
    $sortField: String
    $sortOrder: String
  ) {
    data: getCandidateConnections(
      connectionStatus: $connectionStatus
      offset: $offset
      limit: $limit
      sortField: $sortField
      sortOrder: $sortOrder
      connectionType: $connectionType
      offerType: $offerType
    ) {
      total
      jobPositions {
        id
        jobPosition {
          ${jobPositionQueryFields}
          match {
            id
            invitationText
            isReAcceptable
            documentRequirement
            onlineMatchStatus
            connectionStatus
            offerType
          }
        }
        distance
        recommended
      }
    }
  }
`;
